export default "__VITE_ASSET__7PrJTdb$__"